import { useMemo } from 'react';

import { useOverviewChunksContext } from '../context/OverviewLoaderContext';
import { ChunkedImageProperties } from '../types/chunkedImage';
import { LengthRange } from '../types/lengthRange';

/**
 * A hook for loading in the overview chunks for an image type and range (i.e: for an image lane row)
 * @param {number} imageTypeId
 * @param {LengthRange} range
 * @returns {ChunkedImageProperties[]}
 */
export const useOverviewChunksLoader = (
	imageTypeId: number,
	isUncropped: boolean,
	range: LengthRange,
): ChunkedImageProperties[] => {
	const context = useOverviewChunksContext();
	const chunks = useMemo(
		() => (isUncropped ? context.chunks[imageTypeId]?.uncropped : context.chunks[imageTypeId]?.cropped),
		[isUncropped, context.chunks, imageTypeId],
	);

	return (chunks ?? []).filter(
		(c) =>
			//Overlap start
			(c.range.depthFrom <= range.depthFrom && c.range.depthTo >= range.depthFrom) ||
			//Overlap end
			(c.range.depthFrom <= range.depthTo && c.range.depthTo >= range.depthTo) ||
			//Overlap all
			(c.range.depthFrom <= range.depthFrom && c.range.depthTo >= range.depthTo) ||
			//Inside
			(c.range.depthFrom >= range.depthFrom && c.range.depthTo <= range.depthTo),
	);
};
